import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { COLUMN_MIN_WIDTH_PX } from "@whoosh/design-system/src/apps/PatronApp/screens/multiSlotBooking";
import { Text, HStack } from "@whoosh/design-system/src/components/primitive";

import { ColumnHeader_course$key } from "./__generated__/ColumnHeader_course.graphql";

export const ColumnHeader = ({
  courseRef,
}: {
  courseRef: ColumnHeader_course$key;
}) => {
  const course = useFragment(ColumnHeaderFragmentString, courseRef);

  return (
    <HStack
      minWidth={COLUMN_MIN_WIDTH_PX}
      paddingVertical={2}
      flex={1}
      justifyContent="center"
      backgroundColor="grayscale-0"
    >
      <Text variant="mainSmallSemiBold">{course.name}</Text>
    </HStack>
  );
};

export const ColumnHeaderFragmentString = graphql`
  fragment ColumnHeader_course on Course {
    id
    name
  }
`;
